import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import { TableCellTitle } from '../../styles';
import { updateNote } from '../../../../../containers/NotesPage/actions';
import { Api } from '../../../../../typings/api';

interface TitleProps {
	id: number;
	title: string;
	dispatch: Dispatch<StoreState>;
}

const Title = ({
	id,
	title,
	dispatch,
}: TitleProps) => {
	const divElement = React.useRef<HTMLDivElement>(null);
	const textAreaElement = React.useRef<HTMLTextAreaElement>(null);
	const titleHeight = React.useRef(0);
	const [isEditing, setIsEditing] = React.useState(false);

	const handleClick = () => {
		titleHeight.current = divElement.current!.clientHeight;
		setIsEditing(true);

		setTimeout(() => {
			if (textAreaElement.current) {
				textAreaElement.current.focus();
				const titleLength = title.length * 2;
				textAreaElement.current.setSelectionRange(titleLength, titleLength);
				textAreaElement.current.style.height = `${titleHeight.current}px`;
			}
		}, 0);
	};

	const handleBlur = (value: string) => {
		if (value !== title) {
			dispatch(updateNote(id, { title: value || '-' } as Api.NoteData, false));
		}

		setIsEditing(false);
		titleHeight.current = 0;
	};

	if (isEditing) {
		return (
			<TableCellTitle
				as="textarea"
				ref={textAreaElement}
				defaultValue={title}
				maxLength={255}
				onBlur={e => handleBlur(e.target.value)}
			/>
		);
	}

	return (
		<TableCellTitle
			as="div"
			ref={divElement}
			onClick={handleClick}
		>
			{title}
		</TableCellTitle>
	);
};

export default Title;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotesPage/Table/Row/Title/index.tsx